import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

const mutateAddCommunityInfo = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${GET_COMMUNITIES}/`, data);
};

const useAddCommunityInfoMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddCommunityInfo,
    ...queryParams,
  });

export default useAddCommunityInfoMutation;
